import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { UserType } from '../../../types';
import { parsedParticipantIdsAtom } from '../../../video-sdk/core/room/participant/atoms';
import { RoomEventHandlerMap } from '../../../video-sdk/core/room/types';
import { useLeaveSessionCallback as useBaseLeaveSessionCallback } from '../useLeaveSessionCallback';

export function useClientParticipantDisconnectedEventHandlerCallback({
  useLeaveSessionCallback = useBaseLeaveSessionCallback,
}: {
  /**
   * Dependency injection useful for testing. Defaults to
   * {@link useBaseLeaveSessionCallback}.
   */
  useLeaveSessionCallback?: typeof useBaseLeaveSessionCallback;
} = {}) {
  const leaveSession = useLeaveSessionCallback();
  const getProviderParticipantCount = useAtomCallback(
    useCallback(
      (get) => get(parsedParticipantIdsAtom).filter(({ userType }) => userType === UserType.PROVIDER).length,
      [],
    ),
  );

  return useCallback<RoomEventHandlerMap['participantDisconnected']>(
    function leaveIfProviderLeft(_participant) {
      const providerIsInSession = getProviderParticipantCount() > 0;
      if (providerIsInSession) return;
      leaveSession();
    },
    [getProviderParticipantCount, leaveSession],
  );
}
